import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import api from '../services/api';

export const useInventoryImage = (itemId: string | undefined) => {
  return useQuery({
    queryKey: ['inventoryImage', itemId],
    queryFn: async () => {
      if (!itemId) return null;
      try {
        const response = await api.get(`/uploads/inventory/${itemId}/image`, { responseType: 'blob' });
        return new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(response.data);
        });
      } catch (err: unknown) {
        if (isAxiosError(err) && err.response?.status === 404) {
          return null;
        }
        throw err;
      }
    },
    enabled: !!itemId, // Only run if itemId is provided
    staleTime: 5 * 60 * 1000,
  });
};
